import { render } from "./RadiologyAppointmentsQueueTab.vue?vue&type=template&id=e5428faa"
import script from "./RadiologyAppointmentsQueueTab.vue?vue&type=script&lang=js"
export * from "./RadiologyAppointmentsQueueTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__